import { type FileType } from "@/lib/utils/file-utils";
import { PdfFullViewer } from "./pdf-full-viewer.component";
import { StlFullViewer } from "./stl-full-viewer.component";
import { XmlDocumentViewer } from "./xml-document-viewer.component";
import { FilePreview } from "../file-preview/file-preview.component";
import { Loader2 } from "lucide-react";

interface FileContentProps {
	url: string;
	fileType: FileType;
	fileName?: string;
	isLoading?: boolean;
	onDownload?: () => void;
}

export const FileContent: React.FC<FileContentProps> = ({
	url,
	fileType,
	fileName,
	isLoading,
	onDownload,
}) => {
	if (isLoading) {
		return (
			<div className="flex h-full items-center justify-center">
				<div className="text-center">
					<Loader2 className="h-8 w-8 animate-spin text-white mx-auto mb-4" />
					<p className="text-white/80">Datei wird geladen...</p>
				</div>
			</div>
		);
	}

	switch (fileType) {
		case "pdf":
			return <PdfFullViewer url={url} onDownload={onDownload} />;
		case "3d":
			return <StlFullViewer onDownload={onDownload} url={url} />;
		case "xml":
			return <XmlDocumentViewer url={url} />;
		case "img":
			return (
				<div className="flex h-full items-center justify-center p-4">
					<img
						src={url}
						alt={fileName}
						className="max-h-full max-w-full object-contain"
					/>
				</div>
			);
		default:
			return (
				<div className="flex h-full items-center justify-center">
					<div className="max-h-full max-w-4xl w-full overflow-auto shadow-2xl">
						<FilePreview url={url} fileType={fileType} fileName={fileName} />
					</div>
				</div>
			);
	}
};
